import { apiFundingTypes } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'funding-types';

const config = [
  { actionType: 'getAll', apiPath: `${apiFundingTypes}`, method: get },
  {
    actionType: 'getOne',
    apiPath: (params: Params) => `${apiFundingTypes}/${params.id}`,
    method: get,
  },
  {
    actionType: 'getAllSah',
    apiPath: `${apiFundingTypes}/sah`,
    method: get,
  },
];

export const { getAll, getOne, getAllSah } = createThunks(typePrefix, config);
